// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeAlbum_wrapper__-r4fH"};